export default __webpack_public_path__ + "static/image4-c14663290109e4fa49bc13aa246cfd41.jpg";